module.exports = __webpack_public_path__ + "img/3화_13(3).2a679780.jpg";